<div class="panel" style="background-color: transparent;">
  <h2>{{ title }}</h2>

  <table>

    <thead>
      <tr>
        <th>Nom d'utilisateur</th>
        <th>Prènom</th>
        <th>Nom</th>
        <th>Date d'ajout</th>
        <th>Fuseau horaire</th>
        <th>Role</th>
      </tr>
    </thead>

    <tbody *ngIf="users && users.length > 0">
      <tr *ngFor="let user of users" (click)="showCLUser(user, $event)">
        <td name="Nom d'utilisateur">{{ user.username }}</td>
        <td name="Prènom">{{ user.firstname }}</td>
        <td name="Nom">{{ user.lastname }}</td>
        <td name="Date d'ajout">{{ user.createdAt | tzdate:'short' }}</td>
        <td name="Fuseau horaire">{{ user.timezone }}</td>
        <td name="Role">{{ user.role | cluserrole }}</td>
      </tr>
    </tbody>

    <tbody *ngIf="!users || users.length == 0">
      <tr>
        <td class="text-center" colspan="6">
          <ng-container *ngIf="users && users.length == 0">
            Aucun utilisateur n'a été trouvé
          </ng-container>
          <ng-container *ngIf="!users">
            Chargement...
          </ng-container>
        </td>
      </tr>
    </tbody>

  </table>

</div>

<div class="pagination" *ngIf="users">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="users.length < usersCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ users.length }} / {{ usersCount }}
  </div>
</div>